// src/pages/BeneficiaryManagement.js
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Typography,
  Chip,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "@mui/material";
import Registerd from "../Images/Registered.svg";
import Reffeared from "../Images/Reffered.svg";
import Addicon from "../Images/Add.svg";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import BadgeIcon from "@mui/icons-material/Badge";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PersonIcon from "@mui/icons-material/Person";
import Header from "../Header/Header";
import Abhasearch from "../Abhasearch/Abhasearch";
import { useNavigate } from "react-router-dom";
import { CommonContext } from "../../context/CommonContext";
import { apisPath, paths } from "../../utils/path";
import { authHttp } from "../../services/commonHttpService";
import { calculateAge, formatAbhaId, formatAbhaInput, formatDate } from "../../helpers/commonHelper";
import { AuthContext } from "../../context/AuthContext";
import REGEXS from "../../utils/regex";
import BookAppointmentModal from "../MoComponents/BookAppointmentModal/BookAppointmentModal";
import treatmentIcon from "../Images/Icontreatment.svg";
import ViewIcon from "../../Images/view.svg";

const BeneficiaryManagement = () => {
  const navigate = useNavigate();
  const { setIsLoading, setSnackState } = useContext(CommonContext);
  const { userRole, facilityId } = useContext(AuthContext);
  const [searchType, setSearchType] = useState("ABHA ID");
  const [searchValue, setSearchValue] = useState("");
  const [error, setError] = useState("");
  const [openAbhaModal, setOpenAbhaModal] = useState(false);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [totalPatients, setTotalPatients] = useState(0);
  const [referredToDCCCCount, setReferredToDCCCCount] = useState(0);

  const [openBookModal, setOpenBookModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [existingSessionsCount, setExistingSessionsCount] = useState(0);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  // Search options with their corresponding API keys
  const searchOptions = [
    { type: "ABHA ID", icon: <AccountBoxIcon />, apiKey: "abha" },
    { type: "Patient ID", icon: <BadgeIcon />, apiKey: "patient_id" },
    { type: "Mobile Number", icon: <PhoneIphoneIcon />, apiKey: "mobile" },
    { type: "Name", icon: <PersonIcon />, apiKey: "full_name" },
  ];

  // Helper function to get patient status based on role and conditions
  const getPatientStatus = (row) => {
    if (userRole === 5) {
      if (row?.status_action === 3) return "All Treatment Completed";
      if (row?.status_action === 2) return "Ongoing";
      if (row?.status_action === 1) return "Scheduled";
      if (row?.status_action === 0) return "Pending";
      // Any other status_action value
      return "-";
    } else {
      // workflow_id 1, 2, or 17
      if ([1, 2].includes(row?.workflow_id)) return "Registered";

      if ([17].includes(row?.workflow_id)) return "Refered Back from DCCC";
      // workflow_id 3, 4, 5, or 6
      if ([3, 4, 5, 6].includes(row?.workflow_id)) return "Ongoing";
      // workflow_id 7-14
      if (row?.workflow_id >= 7 && row?.workflow_id <= 14) return "Completed";
    }
    return "N/A";
  };

  // Helper function to get status chip color
  const getStatusColor = (status) => {
    switch (status) {
      case "Ongoing":
        return "warning";
      case "Scheduled":
        return "orange";
      case "Pending":
        return "pending";
      case "Registered":
        return "info";
      case "Completed":
        return "success";
      default:
        return "default";
    }
  };

  // Helper function to get action button details
  const getActionButton = (row) => {
    if (userRole === 5) {
      if (row?.status_action === 2) {
        return {
          label: "Complete Treatment",
          onClick: () => handleInitiateTreatment(row),
          icon: true,
        };
      }
      // if (row?.status_action === 1 || row?.status_action === 9) {
      if (row?.status_action === 1) {
        return {
          label: "Initiate Treatment",
          onClick: () => handleInitiateTreatment(row),
          icon: true,
        };
      }
      if (row?.status_action === 0) {
        return {
          label: "Book Appointment",
          onClick: () => handleBookSlot(row),
          icon: true,
        };
      }
      return {
        label: "Referred to TCCC",
        onClick: null,
        icon: false,
      };
    } else {
      if ([1, 2, 17].includes(row?.workflow_id)) {
        return {
          label: "Initiate Treatment",
          onClick: () => handleInitiateTreatment(row),
          icon: true,
        };
      }
      if ([3, 4, 5, 6].includes(row?.workflow_id)) {
        return {
          label: "Complete Treatment",
          onClick: () => handleInitiateTreatment(row),
          icon: true,
        };
      }
      if (row?.workflow_id >= 7 && row?.workflow_id <= 14) {
        return {
          label: row?.dccc_name || "DCCC",
          fullLabel: row?.dccc_name || "DCCC",
          onClick: null,
          icon: false,
          showTooltip: true,
          isChip: true,
        };
      }
    }
    return null;
  };

  // Fetch patient list
  const fetchPatientList = async (searchParams = null) => {
    setIsLoading(true);
    try {
      const baseUrl = userRole === 5
        ? apisPath?.moPatientList
        : apisPath?.patientList;

      // Build query parameters
      const queryParams = [];

      if (facilityId) {
        queryParams.push(`facility_id=${facilityId}`);
      }

      if (searchParams) {
        queryParams.push(searchParams);
      }

      const url = queryParams.length > 0
        ? `${baseUrl}?${queryParams.join('&')}`
        : baseUrl;


      const response = await authHttp.get(url);

      if (response?.data) {
        setBeneficiaries(userRole === 5 ? response?.data?.data?.result : response?.data?.data);
        setTotalPatients(userRole === 5 ? response?.data?.data?.result.length : response?.data?.data.length);
      }
    } catch (error) {
      console.log(error?.response?.data?.message)
      // setSnackState({
      //   open: true,
      //   message: error?.response?.data?.message || "Failed to fetch patient list",
      //   severity: "error",
      // });
      setBeneficiaries([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle search
  const handleSearch = () => {
    setCurrentPage(1); // Reset to first page when searching
    if (!searchValue.trim()) {
      fetchPatientList();
      return;
    }

    // Finding the API key for the selected search type
    const selectedOption = searchOptions.find(
      (option) => option.type === searchType
    );
    const apiKey = selectedOption?.apiKey;

    if (!apiKey) return;

    if (error) return;

    // Mobile number 10 digits check on search
    if (searchType === "Mobile Number" && searchValue.length !== 10) {
      setError("Mobile number must be exactly 10 digits");
      return;
    }

    // Patient ID max 5 digits check
    if (searchType === "Patient ID" && (searchValue.length === 0 || searchValue.length > 5)) {
      setError("Please enter a valid Patient ID (up to 5 digits)");
      return;
    }

    // Building search parameter
    let searchParam = "";

    // Convert to integer if searching by Patient ID
    if (apiKey === "patient_id") {
      const patientId = parseInt(searchValue);
      if (isNaN(patientId)) {
        setSnackState({
          open: true,
          message: "Please enter a valid Patient ID (numbers only)",
          severity: "error",
        });
        return;
      }
      searchParam = `${apiKey}=${patientId}`;
    } else {
      searchParam = `${apiKey}=${encodeURIComponent(searchValue.trim())}`;
    }

    fetchPatientList(searchParam);
  };

  // Handle Enter key press for search
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // Handle initiate treatment - conditional redirect based on userRole
  const handleInitiateTreatment = (row) => {
    if (userRole === 5) {
      navigate(
        `${paths?.user?.commonPoint}${paths?.user?.treatmentProcedure}`,
        {
          state: {
            patientId: row?.patient_id,
            planned_chemo_cycles: row?.planned_chemo_cycles,
            upcoming_on_min: row?.upcoming_on_min,
            patientName: row?.full_name
          },
        }
      );
    } else {
      navigate(`${paths?.user?.commonPoint}${paths?.user?.treatmentModule}`, {
        state: { patientId: row?.patient_id },
      });
    }
  };

  // Handle view for MI users after refer to DCCC
  const handleReferToDccc = (patientId) => {
    navigate(`${paths?.user?.commonPoint}${paths?.user?.miTreatmentProcedure}`, {
      state: { patientId },
    });
  }

  // Fetch existing sessions count
  const fetchExistingSessionsCount = async (patientId, plannedCycles) => {
    try {
      const response = await authHttp.get(`${apisPath?.getAllChemoSessions}/${patientId}`);

      if (response?.data?.status && response?.data?.data) {
        const count = response?.data?.data.length;
        setExistingSessionsCount(count);

        // Show alert if sessions >= planned cycles (but still proceed)
        if (count >= plannedCycles) {
          setSnackState({
            open: true,
            message: "You have booked all the sessions suggested by TCCC.",
            severity: "error",
          });
        }
      }
    } catch (error) {
      // If API fails, default to 0
      setExistingSessionsCount(0);
    }
  };

  // Handle book slot
  const handleBookSlot = async (patient) => {
    setSelectedPatient({
      patient_id: patient?.patient_id,
      full_name: patient?.full_name,
      planned_chemo_cycles: patient?.planned_chemo_cycles || 0,
    });

    // Fetch existing sessions count
    await fetchExistingSessionsCount(patient?.patient_id, patient?.planned_chemo_cycles);

    setOpenBookModal(true);
  };

  // Handle booking success
  const handleBookingSuccess = () => {
    setOpenBookModal(false);
    setSelectedPatient(null);
    fetchPatientList(); // Refresh list
    setSnackState({
      open: true,
      message: "Appointment booked successfully!",
      severity: "success",
    });
    navigate(
      `${paths?.user?.commonPoint}${paths?.user?.moBeneficiaryManagement}`
    );
  };

  // Fetch patient list on component mount
  useEffect(() => {
    fetchPatientList();
  }, []);

  // Calculate referred to DCCC count
  useEffect(() => {
    if (userRole === 4) {
      const count = beneficiaries.filter(
        (patient) => patient?.workflow_id >= 7 && patient?.workflow_id <= 14
      ).length;
      setReferredToDCCCCount(count);
    }
  }, [beneficiaries, userRole]);

  // Reset search value when search type changes
  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    setSearchValue("");
    setError("");
  };

  return (
    <>
      <Header showFullHeader={false} />
      <Container>
        {/* Header Section */}

        <h5 className="mb-4 margin-top">Beneficiary Management</h5>

        {/* Stats Section */}
        {userRole === 4 && (
          <div className="row mb-4">
            <div className="col-md-3 col-xs-6 mb-3 mb-md-0">
              <div className="bg-white box-design shadow p-3 d-flex align-items-center">
                <img
                  src={Registerd}
                  alt=""
                  className="me-2"
                  style={{ width: "53px" }}
                />
                <div>
                  <h5 className=" mb-0 text-number">{beneficiaries.length}</h5>
                  <div className="text-tile">Registered Patients</div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-xs-6 mb-3 mb-md-0">
              <div className="bg-white box-design shadow p-3 d-flex align-items-center">
                <img
                  src={Reffeared}
                  alt=""
                  className="me-2"
                  style={{ width: "53px" }}
                />
                <div>
                  <h5 className="text-number mb-0">{referredToDCCCCount}</h5>
                  <small className="text-tile">Referred to DCCC</small>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Search Section */}
        <Typography variant="h6" className="fw-bold mb-3">
          Search Beneficiary
        </Typography>

        <div className="d-flex flex-wrap gap-2 mb-3">
          {searchOptions.map((item) => (
            <Button
              key={item?.type}
              variant="outlined"
              onClick={() => handleSearchTypeChange(item?.type)}
              startIcon={item?.icon}
              className={`search-btn ${searchType === item?.type ? "active" : ""
                }`}
            >
              {item?.type}
            </Button>
          ))}
        </div>

        <div className="d-flex flex-column search-main-container mb-4">
          <div className="d-flex flex-wrap gap-2 align-items-center search-bar-container">
            <div className={`d-flex align-items-center search-input-wrapper ${searchType === "Patient ID" ? "has-prefix" : ""}`}>
              {searchType === "Patient ID" && (
                <span className="search-prefix">P-</span>
              )}
              <input
                type="text"
                placeholder={`Enter ${searchType}`}
                size="small"
                value={searchValue}
                onChange={(e) => {
                  const val = e.target.value;
                  setError(""); // Clear error on change
                  
                  if (searchType === "ABHA ID") {
                    setSearchValue(formatAbhaInput(val));
                  } else if (searchType === "Patient ID") {
                    if (val === "" || REGEXS.number.test(val)) {
                      if (val.length <= 5) {
                        setSearchValue(val);
                      } else {
                        setError("Patient ID cannot exceed 5 digits");
                      }
                    } else {
                      setError("Only numbers are allowed for Patient ID");
                    }
                  } else if (searchType === "Mobile Number") {
                    if (val === "" || REGEXS.number.test(val)) {
                      if (val.length <= 10) {
                        setSearchValue(val);
                        if (val.length > 0 && !/^[6-9]/.test(val)) {
                          setError("Mobile number must start with 6-9");
                        }
                      } else {
                        setError("Mobile number cannot exceed 10 digits");
                      }
                    } else {
                      setError("Only numbers are allowed for Mobile Number");
                    }
                  } else if (searchType === "Name") {
                    if (val === "" || REGEXS.name.test(val)) {
                      setSearchValue(val);
                    } else {
                      setError("Only alphabets are allowed for Name");
                    }
                  }
                }}
                onKeyPress={handleKeyPress}
                className="search-bar"
              />
            </div>

            <Button
              variant="contained"
              startIcon={<SearchIcon />}
              className="search-btn"
              onClick={handleSearch}
              disabled={!!error}
            >
              Search
            </Button>
          </div>
          {error && (
            <Typography variant="caption" color="error" className="ms-2 mt-1">
              {error}
            </Typography>
          )}
        </div>

        {/* Table Section */}
        <div className="shadow table-design mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="mb-0 tile-header">Beneficiary List</h6>

            {/* Only show Add Beneficiary button if user can create */}
            {userRole === 4 && (
              <Button
                variant="contained"
                className="rounded-3 mb-2 addBeneficiaryBtn"
                onClick={() => setOpenAbhaModal(true)}
              >
                <img src={Addicon} alt="" />
                Add Beneficiary
              </Button>
            )}
          </div>

          <Abhasearch
            open={openAbhaModal}
            onClose={() => setOpenAbhaModal(false)}
            onSuccess={() => {
              setOpenAbhaModal(false);
              fetchPatientList(); // Refresh list after adding new beneficiary
            }}
          />

          <div className="table-responsive mt-2">
            <table className="table align-middle mb-0 custom-table">
              <thead>
                <tr>
                  <th>Patient ID</th>
                  <th>Name</th>
                  <th>Age</th>
                  <th>Gender</th>
                  <th>ABHA ID</th>
                  <th>Mobile Number</th>
                  <th>Registration</th>
                  {userRole === 5 &&
                    <>
                      <th>Last Treatment</th>
                      <th>Next Treatment</th>
                    </>
                  }
                  <th>Status</th>
                  <th>Action</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {beneficiaries.length > 0 ? (
                  beneficiaries
                    .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                    .map((row, i) => {
                      const status = getPatientStatus(row);
                      const actionButton = getActionButton(row);

                      return (
                        <tr key={row?.patient_id || i}>
                          <td>P-{row?.patient_id}</td>
                          <td>{row?.full_name}</td>
                          <td>{calculateAge(row?.dob)}</td>
                          <td>{row?.gender}</td>
                          <td>{formatAbhaId(row?.abha)}</td>
                          <td>{row?.mobile}</td>
                          <td>{userRole === 5 ? formatDate(row?.created_date) : formatDate(row?.created_at)}</td>
                          {userRole === 5 &&
                            <>
                              <td>{row?.completed_on_max ? formatDate(row?.completed_on_max) : "-"}</td>
                              <td>{row?.upcoming_on_min ? formatDate(row?.upcoming_on_min) : "-"}</td>
                            </>
                          }
                          <td>
                            <Chip
                              label={status}
                              color={getStatusColor(status)}
                              size="small"
                              variant="outlined"
                              // className="border-radi"
                              className={`${getStatusColor(status)} border-radi`}
                            />
                          </td>
                          <td>
                            {actionButton ? (
                              actionButton.isChip ? (
                                <Tooltip title={`Referred to ${actionButton?.fullLabel}`} arrow placement="top">
                                  <Chip
                                    label={`Referred to ${actionButton?.label}`}
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className="referred-chip"
                                  />
                                </Tooltip>
                              ) : (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={actionButton.onClick}
                                  disabled={!actionButton.onClick}
                                  className="cusom-padding"
                                >
                                  {actionButton?.icon ? (
                                    <img
                                      src={treatmentIcon}
                                      alt=""
                                      className="treatment-icon"
                                    />
                                  ) : null}
                                  <span>
                                    {actionButton?.label}
                                  </span>
                                </Button>
                              )
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                -
                              </Typography>
                            )}
                          </td>
                          <td>
                            {userRole === 5 ? ""
                              : ((row?.workflow_id >= 7 && row?.workflow_id <= 14) &&
                                <img
                                  src={ViewIcon}
                                  className="viewBtn"
                                  alt="view button"
                                  onClick={() => handleReferToDccc(row?.patient_id)}
                                />
                              )
                            }
                          </td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center p-4">
                      <Typography variant="body2" color="text.secondary">
                        No beneficiaries found
                      </Typography>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <Typography variant="body2">
              {beneficiaries.length} results found Showing page {currentPage} of {Math.ceil(beneficiaries.length / itemsPerPage) || 1}
            </Typography>
            <nav>
              <ul className="pagination mb-0">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                </li>

                {(() => {
                  const totalPages = Math.max(1, Math.ceil(beneficiaries.length / itemsPerPage));
                  const pageNumbers = [];

                  if (totalPages <= 3) {
                    for (let i = 1; i <= totalPages; i += 1) pageNumbers.push(i);
                  } else if (currentPage === 1) {
                    pageNumbers.push(1, 2, 3);
                  } else if (currentPage === totalPages) {
                    pageNumbers.push(totalPages - 2, totalPages - 1, totalPages);
                  } else {
                    pageNumbers.push(currentPage - 1, currentPage, currentPage + 1);
                  }

                  return pageNumbers.map((num) => (
                    <li key={num} className={`page-item ${currentPage === num ? 'active' : ''}`}>
                      <button
                        className="page-link"
                        style={currentPage === num ? { backgroundColor: '#8d66c3', borderColor: '#8d66c3', color: '#fff' } : {}}
                        onClick={() => setCurrentPage(num)}
                      >
                        {num}
                      </button>
                    </li>
                  ));
                })()}

                <li className={`page-item ${currentPage >= Math.ceil(beneficiaries.length / itemsPerPage) ? 'disabled' : ''}`}>
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(prev => Math.min(Math.ceil(beneficiaries.length / itemsPerPage), prev + 1))}
                    disabled={currentPage >= Math.ceil(beneficiaries.length / itemsPerPage) || beneficiaries.length === 0}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>

      </Container>

      {selectedPatient && (
        <BookAppointmentModal
          open={openBookModal}
          onClose={() => {
            setOpenBookModal(false);
            setSelectedPatient(null);
            setExistingSessionsCount(0);
          }}
          patientId={selectedPatient?.patient_id}
          patientName={selectedPatient?.full_name}
          planned_chemo_cycles={selectedPatient?.planned_chemo_cycles || 0}
          existingSessionsCount={existingSessionsCount}
          onSuccess={handleBookingSuccess}
        />
      )}
    </>
  );
};

export default BeneficiaryManagement;
